export default function tooltipConfig($uibTooltipProvider) {
	$uibTooltipProvider.setTriggers({
		"mouseenter": "mouseleave blur click",
		"click": "click",
		"focus": "blur",
		"never": "mouseleave"
	});
	$uibTooltipProvider.options({
		appendToBody: "true"
	});
}